export default {
  faq: {
    title_small: "FAQ",
    title1: "Questions?",
    title2: "We’ve Got You Covered",

    q1: "What is MAHAL?",
    a1: "MAHAL is a B2B food procurement platform connecting restaurants with verified suppliers for transparent and reliable sourcing.",

    q2: "How does the platform work?",
    a2: "Restaurants browse suppliers, place orders, make secure payments, and receive scheduled deliveries through MAHAL.",

    q3: "Who can join MAHAL?",
    a3: "Restaurants, suppliers, and business partners can join MAHAL to grow their operations.",

    q4: "Is support available?",
    a4: "Yes, our support team assists businesses with onboarding, orders, and delivery coordination.",

    cta: "Still Have Questions?",
  },
};